// UnitPermissionTree
// ***********************************************************************************************************************
import { Avatar, Box, Grid, ListItemButton, Typography } from "@mui/material";
import * as React from "react";
import { ListStateIconTool } from "source/components/framework/List/ListStateIconTool";
import { EnumHelper, GroupPermissionLevel } from "ui/Scripts/source/models/enums";
import { IFolderNode } from "ui/Scripts/source/models/document/folderNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIconExpanded } from "source/components/framework/List/ListStateIconExpanded";
import { AppIconFolder } from "source/components/framework/Icon/AppIconFolder";

export interface IFolderPermissionTreeProp {
    classes?: string;
    level?: number;
    height: string | number;
    folderNode: IFolderNode;
    selectedId?: string;
    isFirstNode: boolean;
    onClick: (id: string) => void;
    onOpen: (id: string) => void;
}

export class FolderPermissionTree extends React.Component<IFolderPermissionTreeProp, {}> {
    handleFolderNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.folderNode.id);
    };
    
    handleFolderNodeDoubleClick = (e) => {
        const props = this.props;
        if (e) {
            e.stopPropagation();
        }
        props.onOpen(props.folderNode.id);
    };

    render() {
        const props = this.props;
        const folderNode = props.folderNode;
        if (!folderNode || (!props.isFirstNode && folderNode.parent && folderNode.getAncesterIsCollapsed())) return null;
        const hasChildren = folderNode.children.length > 0;
        const isRoot = folderNode.getIsRoot();
        let selectedId = props.selectedId;
        if (!props.selectedId && isRoot) {
            selectedId = folderNode.id;
        }
        const permission = folderNode.permission.permission;
        const permissionText = EnumHelper.isGreaterOrEqualThan(permission, GroupPermissionLevel.Write)
            ? Translations.AccessRightWrite
            : (EnumHelper.isEqual(permission, GroupPermissionLevel.Read) ? Translations.AccessRightRead : Translations.AccessRightNone);
        return (
            <Box sx={{
                maxHeight: props.isFirstNode ? props.height : null,
                overflowX: "hidden",
                overflowY: "auto",
            }}>
                <ListItemButton
                    selected={selectedId === props.folderNode.id}
                    onClick={this.handleFolderNodeClick}
                    onDoubleClick={this.handleFolderNodeDoubleClick}
                >
                    <Grid container alignItems="center">
                        <Grid item sm={7}>
                            <Box display="flex" alignItems="center" sx={{ paddingLeft: (10 * props.level).toString(10) + "px", width: "100%" }}>
                                {!folderNode.getIsRoot() && (
                                    <ListStateIconExpanded
                                        collapsed={!props.folderNode.expanded}
                                        hasChildren={hasChildren}
                                        noMargin
                                    />
                                )}
                                {(!folderNode.image
                                    ? <AppIconFolder sx={{ width: 24, height: 24, marginRight: ".5rem" }} />
                                    : <Avatar
                                        src={folderNode.image}
                                        sx={{ width: 24, height: 24, backgroundColor: "#bfc9ca", marginRight: ".5rem" }}
                                    >
                                    </Avatar>
                                )}
                                <span className={"icon access level" + Math.min(folderNode.permission.permission, GroupPermissionLevel.Write).toString(10)}></span>
                                <Typography
                                    fontWeight={selectedId === props.folderNode.id ? 600 : 400}
                                    sx={{
                                        marginLeft: "20px",
                                        maxWidth: "calc(100% - " + (20 + 24 + 8 + 20 + 20 + 8) + "px)",
                                        maxHeight: "40px",
                                        overflow: "hidden"
                                    }}
                                    title={folderNode.name}
                                >
                                    {folderNode.name}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item sm={5}>
                            <Box display="flex" className={(folderNode.permission.isExplicitPermission ? "" : " inherited")} onClick={() => this.handleFolderNodeDoubleClick(null)}>
                                {folderNode.permission.isExplicitPermission &&
                                    <ListStateIconTool noMargin />
                                }
                                {permissionText
                                    ? <Typography
                                        fontWeight={selectedId === props.folderNode.id ? 600 : 400}
                                        sx={{ color: folderNode.permission.isExplicitPermission ? "text.primary" : "text.secondary", marginLeft: folderNode.permission.isExplicitPermission ? ".5rem" : 0 }}
                                    >
                                        {permissionText}
                                    </Typography>
                                    : "&nbsp;"}
                            </Box>
                        </Grid>
                    </Grid>
                </ListItemButton>
                {folderNode.children.map((child) =>
                    <FolderPermissionTree
                        key={child.id}
                        folderNode={child}
                        selectedId={selectedId}
                        isFirstNode={false}
                        height={undefined}
                        level={props.level ? (props.level + 1) : 1}
                        onClick={props.onClick}
                        onOpen={props.onOpen}
                    />
                )}
            </Box>
        );
    }
}